import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serverList } from "@/api/gmToolNew/gmToolNew";
import serverManageList from "./serverManageList.vue";
import kickPlayerOffline from "./kickPlayerOffline.vue";
import kickPlayerOutLine from "./kickPlayerOutLine.vue";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
export default {
  name: "serverManagement",
  components: {
    kickPlayerOffline: kickPlayerOffline,
    serverManageList: serverManageList,
    kickPlayerOutLine: kickPlayerOutLine
  },
  mixins: [gmToolNew, gmToolNewPage],
  data: function data() {
    return {
      activeIndex: 'serverManageList'
    };
  },
  created: function created() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};